import { ArrowRight, Building2, User, Store, Database } from "lucide-react";

export function WalletFlow() {
  const wallets = [
    {
      icon: Building2,
      label: "Provider Wallet",
      description: "Eatzy platform",
      color: "bg-info/10 text-info border-info/20",
      type: "provider",
    },
    {
      icon: User,
      label: "User Wallet",
      description: "Customer points",
      color: "bg-kudoz/10 text-kudoz border-kudoz/20",
      type: "user",
    },
    {
      icon: Store,
      label: "Restaurant Wallet",
      description: "Merchant account",
      color: "bg-success/10 text-success border-success/20",
      type: "restaurant",
    },
  ];

  return (
    <div className="space-y-4 fm-fade-up">
      <div className="flex items-center justify-center gap-2 px-4 py-2 bg-muted/50 rounded-lg border border-border">
        <Database className="w-4 h-4 text-muted-foreground" />
        <p className="text-xs text-muted-foreground text-center">
          <span className="font-medium text-foreground">Same database table</span>
          {" "}— All wallets are stored in one table, differentiated by{" "}
          <code className="px-1.5 py-0.5 bg-background rounded text-[10px] font-mono">wallet_type</code>
          {" "}field (provider, user, restaurant)
        </p>
      </div>
      
      <div className="flex flex-col md:flex-row items-center justify-center gap-2 md:gap-4 py-2">
        {wallets.map((wallet, index) => (
          <div key={wallet.label} className="flex items-center gap-2 md:gap-4">
            <div
              className={`flex flex-col items-center gap-2 p-4 rounded-xl border ${wallet.color} min-w-[140px]`}
            >
              <wallet.icon className="w-6 h-6" />
              <div className="text-center">
                <p className="font-medium text-sm">{wallet.label}</p>
                <p className="text-xs opacity-75">{wallet.description}</p>
              </div>
              <code className="px-2 py-0.5 bg-background/50 rounded text-[10px] font-mono opacity-75">
                type: "{wallet.type}"
              </code>
            </div>
            {index < wallets.length - 1 && (
              <ArrowRight className="w-5 h-5 text-muted-foreground hidden md:block" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
